import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import Picker from '../Picker';
import { getHours, getMinutes } from '../utils';
import Filter from '@helpers/Filter';

interface IProps {
  title?: string;
  value?: string; //传入的初始时间值
  onConfirm: (value: string) => void;
  onClose: () => void;
}

const EasyTimePicker = (props: IProps): any => {
  const { onConfirm, onClose } = props;
  const keys = ['hour', 'minute'];
  const keysCreators = {
    [keys[0]]: getHours(),
    [keys[1]]: getMinutes(),
  };
  const keysData = keys.reduce(function(result, key, i) {
    result[key] = keysCreators[key];
    return result;
  }, {});
  const [columns, setColumns] = useState(null);
  const [currentTime, setCurrentTime] = useState({
    hour: '00',
    minute: '00',
  });

  const updateDatetime = (columnIndex: number, itemIndex: number) => {
    const key = keys[columnIndex];
    const item = keysCreators[key][itemIndex];
    const value = item?.value;
    setCurrentTime({
      ...currentTime,
      [key]: value,
    });
  };

  const getDatetimeByHour = (datetime?: string) => {
    let value = datetime || Filter.date(Date.now(), 'hourWithMinute');
    const values = value.split(':');
    return keys.reduce(function(result, key, i) {
      result[key] = values[i];
      return result;
    }, {});
  };

  const confirm = () => {
    onConfirm && onConfirm(currentTime.hour + ':' + currentTime.minute);
    onClose && onClose();
  };
  const close = () => {
    onClose && onClose();
  };

  const initColumns = () => {
    const dateTime = getDatetimeByHour(props.value);
    setCurrentTime(dateTime as { hour: string; minute: string });
    let column = [];
    column = keys.map(key => ({
      code: key,
      initialIndex: keysData[key].findIndex(
        (v: { label: string; value: string }) => v.value === dateTime[key],
      ),
      values: keysData[key].map(
        (item: { label: string; value: string }) => item.label,
      ),
    }));
    setColumns(column);
  };

  useEffect(() => {
    initColumns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!columns?.length) {
    return null;
  }

  return ReactDOM.createPortal(
    <Picker
      title={props.title || '选择时间'}
      columns={columns}
      onConfirm={confirm}
      onClose={close}
      onPick={updateDatetime}
    />,
    document.getElementById('modal') as HTMLDivElement,
  );
};

export default EasyTimePicker;
